import React from 'react';

// const DotsMenuIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="currentColor"
//     className="text-muted"
//     style={{ cursor: 'pointer', opacity: 0.5, flexShrink: 0 }}
//   >
//     <circle cx="8" cy="3" r="1.5" />
//     <circle cx="8" cy="8" r="1.5" />
//     <circle cx="8" cy="13" r="1.5" />
//   </svg>
// );

interface ChartCardProps {
  title: string;
  sub: string;
  children: React.ReactNode;
  /** Optional element rendered top-right beside the menu icon (e.g. a badge) */
  extra?: React.ReactNode;
  /** Hide the ⋮ menu icon */
  noMenu?: boolean;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, sub, children, extra, noMenu }) => (
  <div
    className="card p-3 h-100"
    style={{ borderRadius: 'var(--bs-border-radius-lg)', display: 'flex', flexDirection: 'column' }}
  >
    <div className="d-flex justify-content-between align-items-start mb-2">
      <div>
        <h6 className="fw-bold mb-0" style={{ fontSize: 14 }}>
          {title}
        </h6>
        <div className="text-muted" style={{ fontSize: 11, marginTop: 2 }}>
          {sub}
        </div>
      </div>
      <div className="d-flex align-items-center gap-2">
        {extra}
        {/* {!noMenu && <DotsMenuIcon />} */}
      </div>
    </div>
    {children}
  </div>
);

export default ChartCard;
